import { ReactNode } from 'react';
import { formatNumericValue } from 'utils/general';

import { Typography } from '@/shared/components/atoms';
import TippyTooltip from '@/shared/components/atoms/TippyTooltip';
import { useStore } from '@/shared/hooks/context/createGenericContext';

import InfoCircle from '~/images/shared/ExleminationMark.svg';

const Card: React.FC<{
  icon: ReactNode;
  subTitle: string;
  number: number;
  showCurrency?: boolean;
  info?: string;
}> = ({ icon, subTitle, number, showCurrency = false, info = undefined }) => {
  const [selectedAsset] = useStore((store) => store?.asset);

  return (
    <div className='flex w-full flex-col gap-1 rounded-2xl border-xs border-neutralVariant-90 bg-background-neutral-99 p-16'>
      <div className='flex items-center gap-2 text-24 text-primary-default'>
        {icon}
        <Typography variant='caption' className='text-surface-10'>
          {subTitle}
        </Typography>
      </div>
      <div className='flex items-center gap-1'>
        <Typography variant='h2' weight='medium'>
          {formatNumericValue(number ?? 0)}{' '}
          {showCurrency && selectedAsset && (
            <span className='text-14'>{selectedAsset.currency}</span>
          )}
        </Typography>
        {info && (
          <TippyTooltip
            padding='p-1'
            content={<Typography variant='caption'>{info}</Typography>}
            maxWidth={300}
            className='cursor-pointer px-2'
          >
            <InfoCircle width='16' height='16' />
          </TippyTooltip>
        )}
      </div>
    </div>
  );
};

export { Card };
